export default "__VITE_ASSET__c269a7b5__"